export type CorrectionStatus = 'PENDING' | 'APPROVED' | 'REJECTED' | 'CANCELLED';
export type CorrectionAction = 'ADD' | 'MODIFY' | 'VOID';
export type CorrectionPunchType = 'IN' | 'OUT';

export type CorrectionDeclaredLocation = 'OFFICE' | 'REMOTE';

export interface CorrectionItem {
  id: string;
  action: CorrectionAction;
  targetPunchId: string | null;
  proposedEventAt: string | null;
  proposedType: CorrectionPunchType | null;
  proposedDeclaredLocation?: CorrectionDeclaredLocation | null;
  appliedPunchId?: string | null;
}

export interface CorrectionSummary {
  id: string;
  requesterUserId: string;
  targetUserId: string;
  targetDate: string;
  reason: string;
  status: CorrectionStatus;
  decidedAt: string | null;
  decisionNotes: string | null;
  createdAt: string;
  updatedAt: string;
  items: CorrectionItem[];
  requester?: { id: string; fullName: string; email: string };
  approver?: { id: string; fullName: string; email: string } | null;
}

export const STATUS_LABEL: Record<CorrectionStatus, string> = {
  PENDING: 'Pendiente',
  APPROVED: 'Aprobada',
  REJECTED: 'Rechazada',
  CANCELLED: 'Cancelada',
};

export type BadgeTone = 'neutral' | 'amber' | 'green' | 'red' | 'blue';

export const STATUS_TONE: Record<CorrectionStatus, BadgeTone> = {
  PENDING: 'amber',
  APPROVED: 'green',
  REJECTED: 'red',
  CANCELLED: 'neutral',
};

export const ACTION_LABEL: Record<CorrectionAction, string> = {
  ADD: 'Añadir',
  MODIFY: 'Modificar',
  VOID: 'Anular',
};
